import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router/router';
import store from '@/store/index';
import Antd from 'ant-design-vue';
import { plugin, defaultConfig } from '@formkit/vue';
import 'ant-design-vue/dist/reset.css';
// eslint-disable-next-line import/extensions
import '@formkit/themes/genesis';
import { genesisIcons } from '@formkit/icons';
import { DraggableResizableVue } from 'draggable-resizable-vue3';
import Vue3ColorPicker from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';

createApp(App)
  .use(router)
  .use(store)
  .use(Antd)
  .use(plugin, defaultConfig({
    icons: {
      ...genesisIcons,
    },
  }))
  .use(DraggableResizableVue)
  .use(Vue3ColorPicker)
  .mount('#app');
